class FaqRenderer {
  constructor() {
    this.__bindViewMoreButtonClickListenerForEachFAQSection();
  }
  showQuestions(allQuestionsElements) {
    allQuestionsElements.forEach(curElement => {
      curElement.style.display = 'block';
      setTimeout(() => {
        curElement.classList.remove('hide-with-animation');
      });
    });
  }
  removeLinkFromTheDOM(viewMoreLinkEl) {
    viewMoreLinkEl.remove();
  }
  onViewMoreLink(viewMoreLinkEl, allQuestionsElements) {
    // In the event listener, remove the display property and then remove the class "hide-with-animation" class from all elements with "fp-item" class
    return _ => {
      this.showQuestions(allQuestionsElements);
      this.removeLinkFromTheDOM(viewMoreLinkEl);
    };
  }
  __bindViewMoreButtonClickListenerForEachFAQSection() {
    const allQuestionsContainers = document.querySelectorAll('.all-questions');
    allQuestionsContainers.forEach(curContainer => {
      const allQuestions = curContainer.querySelectorAll('.fp-item');
      const viewMoreLink = curContainer.querySelector('.all-questions-view-more-button');
      viewMoreLink?.addEventListener('click', this.onViewMoreLink(viewMoreLink, allQuestions));
    });
  }
}
new FaqRenderer();
